import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: '70%',
		padding: '0',
		textAlign: 'left',
		margin: '0 auto !important'
	},
	inputConfigContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	}
}));
